import { useEffect } from 'react';
export function useFormLoadObserver(containerRef, onLoaded, deps) {
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    if (container.dataset.loaded) {
      onLoaded();
      return;
    }
    if (!container.dataset.fetched) {
      const parent = container.parentNode;
      if (parent) {
        const next = container.nextSibling;
        container.remove();
        parent.insertBefore(container, next);
      }
    }
    const observer = new MutationObserver(() => {
      if (container.dataset.loaded) {
        onLoaded();
        observer.disconnect();
      }
    });
    observer.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-loaded']
    });
    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}